import { newAxiosIns, komshipAxiosIns } from '@/libs/axios'

export default function apiGetWhatsAppList() {
  return newAxiosIns.get('komchat-api/api/v1/agent/available_phone')
}

export function apiGetFullWhatsAppList() {
  return newAxiosIns.get('/komship/api/v1/whatsapp/list')
}

export function apiDeleteWhatsApp(id) {
  return newAxiosIns.delete(`/komship/api/v1/whatsapp/delete/${id}`)
}

export function apiCheckWhatsApp(phoneNumber) {
  return komshipAxiosIns.get('/v1/setting/check-number', {
    params: { phone_number: phoneNumber },
  })
}

export function apiAddWhatsApp(phoneNumber, partnerId) {
  return komshipAxiosIns.post('/v2/wap/add-number', {
    partner_id: partnerId,
    phone_number: phoneNumber,
  })
}

export function apiUpdateWhatsAppType(id, type = 'komchat_ai') {
  return newAxiosIns.put(`/komship/api/v1/whatsapp/update-type/${id}`, {
    type,
  })
}
